/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @typescript-eslint/no-shadow */
import { H5_DOMAIN_NAME } from '@base/constants'
import { setUrl } from '@fe/utils'
import * as Browser from './browser'
import { isH5Container } from './browser'
import { getApolloConfig } from '@r/page/src/pages/common/api/services'
import storage from '@base/utils/storage'
import { WX_MINI_CONFIG, WX_BASE_CONFIG_LIST } from '@r/page/src/config'
import type { ClientRouteProps } from './clientRoute'
import dayjs from 'dayjs'
import dayjsIsBetween from 'dayjs/plugin/isBetween'
import { getUrl } from '@fe/utils'
import qs from 'qs'
dayjs.extend(dayjsIsBetween)

export type GetOpenAppOptionParams = {
  encodeTarget?: string
  timeout?: number
  debug?: boolean
  PACKAGE?: string
  SOURCE?: string
  DEF_APK_URL?: string
  APP_STORE_ADDRESS?: string
}

export function isDuringDate(curDatetimeStr: number, beginDatetimeStr: number, endDatetimeStr: number): boolean {
  return beginDatetimeStr && endDatetimeStr && curDatetimeStr >= beginDatetimeStr && curDatetimeStr <= endDatetimeStr
}

interface allowRolerParams {
  userTags: string[]
  userEnv: string
  componentTags: string | string[]
  componentEnv: string | string[]
}

export const isAllowedRoler = (params: allowRolerParams) => {
  const { userTags = [], userEnv, componentTags, componentEnv } = params
  // 如果是web，则不判断身份和渠道
  if (userEnv === 'web') return true

  // 为什么写的这么复杂？ 因为cms后台会传2种格式过来 1、‘1,2,3’  2、[''] | ['1', '2']
  const tags = typeof componentTags == 'string' ? (componentTags ? componentTags.split(',') : []) : componentTags?.join(',') ? componentTags : []
  const env = typeof componentEnv == 'string' ? (componentEnv ? componentEnv.split(',') : []) : componentEnv?.join(',') ? componentEnv : []
  // 判断!env.length是为了兼容古老数据，后台没有选择渠道时需要默认展示，千万不要删掉！！改4遍了....
  const isEmptyEnv = !env.length
  // web cms后台没有这个枚举值，默认所有组件web端都展示
  if (!env.includes(Browser.clientEnv.web)) {
    env.push(Browser.clientEnv.web)
  }

  const isVisableUser = tags.length ? userTags.some((tag) => tags.includes(tag)) : true

  const isVisableEnv = env.some((cur) => cur === Browser.clientEnv[userEnv]) || isEmptyEnv

  return isVisableUser && isVisableEnv
}

export function getDateTime(dateStr: string): number {
  if (!dateStr.length) return 0

  const date = dateStr.trim().split(/T|\s/)

  let dateForMYD: number[]
  let dateForTime: number[]

  if (date[0]) {
    dateForMYD = date[0].split('-').map((item) => Number(item))
    dateForMYD[1]--
  }

  if (date[1]) {
    dateForTime = date[1].split(':').map((item) => Number(item))
  }

  return new Date(dateForMYD[0], dateForMYD[1], dateForMYD[2], dateForTime[0], dateForTime[1], dateForTime[2]).getTime()
}

export function replaceUrlQuery(originUrl: string, key: string, newValue: string | number) {
  const url = originUrl.split('?')[1] || ''
  const path = originUrl.split('?')[0]
  if (!~url.indexOf(key)) {
    return !~originUrl.indexOf('?') ? `${path}?${url}${key}=${newValue}` : `${path}?${url}&${key}=${newValue}`
  }
  const idx = url.indexOf(key) + key.length + 1
  const arr = url.slice(idx).split('&')
  const endV = arr.length > 1 ? '&' + (arr.shift() && arr.join('&')) : ''
  return `${path}?${url.slice(0, idx)}${newValue}${endV}`
}

export function getUrlParams(originUrl: string, key: string) {
  const url = originUrl.split('?')[1] || ''
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  if (url) {
    const r = url.match(reg)
    if (r != null) {
      return r[2]
    }
    return ''
  }
  return ''
}

interface urlsObj {
  miniProgram: string
  client: string
  web: string
}
export function filterUrl(urls: urlsObj): string {
  if (Browser.isSunriseClient) {
    return urls.client || ''
  }
  if (Browser.isMiniProgram) {
    return urls.miniProgram || ''
  }
  return urls.web || ''
}

export enum ComponentType {
  header = 'sr_cms_header',
  column = 'sr_cms_column',
  goods = 'sr_cms_goods',
  coupon = 'sr_cms_coupon',
  anchor = 'sr_cms_anchor',
  divider = 'sr_cms_divider',
  hotzone = 'sr_cms_hotzone',
  tabbar = 'sr_cms_tabbar',
  swiper = 'sr_cms_swiper',
  lottery = 'sr_cms_lottery',
  redeem = 'sr_cms_redeem',
  votes = 'sr_cms_guess',
  price = 'sr_cms_price',
  video = 'sr_cms_video',
  search = 'sr_cms_search',
  waterfall = 'sr_cms_waterfall',
  qa = 'sr_cms_qa',
  shareEntry = 'sr_cms_shareEntry',
  share = 'sr_cms_share',
  toptab = 'sr_cms_toptab',
}

export enum StaticsType {
  sr_cms_header = '页头组件',
  sr_cms_column = '分栏组件',
  sr_cms_goods = '商品组件',
  sr_cms_coupon = '领券组件',
  sr_cms_anchor = '锚定组件',
  sr_cms_divider = '中插组件',
  sr_cms_hotzone = '热区组件',
  sr_cms_tabbar = '底导组件',
  sr_cms_swiper = '轮播组件',
  sr_cms_lottery = '抽奖组件',
  sr_cms_redeem = '兑奖组件',
  sr_cms_guess = '投票组件',
  sr_cms_price = '价格组件',
  sr_cms_video = '视频组件',
  sr_cms_search = '搜索栏组件',
  sr_cms_waterfall = '瀑布流组件',
  sr_cms_qa = '答题组件',
  sr_cms_share = '分享券组件',
  sr_cms_shareEntry = '分享入口组件',
  sr_cms_toptab = '顶导组件',
}

// 组件曝光埋点 start
const eleIds = []
export function createObserver(dom, callback: (param?: { code: number; id: string }) => void) {
  let observer = null
  const options = {
    root: null,
    rootMargin: '15px',
    threshold: buildThresholdList(),
  }
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        if (checkUniqueId(entry.target.id)) {
          console.log('ratio', entry.target.id, entry.intersectionRatio)
          eleIds.push(entry.target.id)
          callback({
            code: 0,
            id: entry.target.id,
          })
        }
      }
    })
  }, options)

  observer.observe(dom)
}

function checkUniqueId(id) {
  return !~eleIds.indexOf(id)
}

function buildThresholdList() {
  const threshold = []
  const numsteps = 10
  for (let i = 0; i <= numsteps; i++) {
    threshold.push(i / numsteps)
  }
  return threshold
}
// 组件曝光埋点 end

const clientWidth = document.body.clientWidth
export function getImageSize(src) {
  if (!src) return { width: 0, height: 0 }
  let w, h
  try {
    w = src.match(/__w\d+/g)[0].substring(3)
    h = src.match(/__h\d+/g)[0].substring(3)
  } catch (error) {
    const img = new Image()
    img.src = src
    w = img.width
    h = img.height
  }
  return {
    width: clientWidth,
    height: (h / w) * clientWidth,
  }
}

/**
 * 观察dom是否在可见范围内
 * @param dom
 * @param callback
 */
export function createIntersectionObserver(dom, callback) {
  let observer = null
  const options = {
    root: null,
    rootMargin: '15px',
  }
  observer = new IntersectionObserver((entries) => {
    entries.forEach((item) => {
      if (item.isIntersecting) {
        callback(item)
        observer.unobserve(item.target)
      }
    })
  }, options)

  observer.observe(dom)
}

function checkIOSVersion() {
  // const ua = window.navigator.userAgent.toLowerCase()
  // return ua.match(/cpu iphone os(.*?) like mac os/)
  const agent = window.navigator.userAgent
  const start = agent.indexOf('OS')
  if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
    return window.Number(agent.substr(start + 3, 3).replace('_', '.'))
  }
  return 0
}

/** 直接设置图片webp地址 */
export const setWebpImgUrl = (url: string) => {
  const image_process = getUrl(url, 'image_process')
  return setUrl(url, 'image_process', image_process ? `${image_process}/format,webp` : 'format,webp')
}

export function getWebpImage(url: string) {
  if (!url) {
    return ''
  }
  const platform = window.navigator?.platform || ''
  const version = checkIOSVersion()
  if (version <= 13 && version > 0 && platform !== 'MacIntel') {
    // TODO 后续优化判断
    return url
  }
  const image_process = getUrl(url, 'image_process')
  return setUrl(url, 'image_process', image_process ? `${image_process}/format,webp` : 'format,webp')
}

export function getUrlOmitSearchString(url: string) {
  try {
    const instance = new URL(url)
    return instance.protocol + '//' + instance.host + instance.pathname
  } catch (e) {
    console.error(e)
    return window.location.protocol + '//' + window.location.host + window.location.pathname
  }
}

export function getUniversalUrls(urls: ClientRouteProps['urls']) {
  if (isH5Container) {
    urls.web = urls.web?.startsWith('http') ? urls.web : H5_DOMAIN_NAME + (urls.mini?.startsWith('/') ? urls.mini : `/${urls.mini}`)
  }
  return urls
}

/** 数字每隔三位加逗号 例如：  123456789 -> 123,456,789 */
export function toThousandsNum(num) {
  const reg = /(\d)(?=(?:\d{3})+$)/g
  return num.toString().replace(reg, '$1,')
}

/**
 * @description 根据时间筛选数据
 */
export function GetCurContentByTime(contents: { startTime: string; endTime: string }[]) {
  let result = null
  let flag = false
  contents.forEach((cur) => {
    const { startTime, endTime } = cur || {}

    // 如果多个tab都没设置时间
    if (!startTime && !endTime && !flag) {
      result = cur
    }

    if (startTime && endTime && dayjs().isBetween(startTime, endTime)) {
      result = cur
      flag = true
    }
  })

  return result
}

/** 获取更新 前端apollo开关 基础配置  */
export const initAndUpFrontConfigList = async () => {
  try {
    const { data } = await getApolloConfig({ keys: [WX_MINI_CONFIG] })
    const res = JSON.parse(data?.[WX_MINI_CONFIG])

    console.log(res, 'front Objec')

    if (Object.prototype.toString.call(res) === '[object Object]') {
      const newObj = {}
      Object.keys(res).forEach((key) => {
        const keymap = res?.[key]?.keymap
        Object.keys(keymap).forEach((subKey) => {
          const subItem = keymap?.[subKey]
          newObj[subKey] = subItem.value
        })
      })
      storage.set(WX_BASE_CONFIG_LIST, newObj)
      return
    }

    storage.set(WX_BASE_CONFIG_LIST, res)
  } catch (e) {
    console.log(e, '>>>error')
  }
}

/** 通过key 获取 前端apollo开关 层配置数据 */
export const getFrontBaseConfigTxt = (key: string) => {
  const frontConfig = storage.get(WX_BASE_CONFIG_LIST) || ([] as any)

  if (Object.prototype.toString.call(frontConfig) === '[object Object]') {
    return frontConfig?.[key]
  }

  const res = frontConfig?.find((t) => t.key === key)
  return res?.value || ''
}

/**
 * @description 判断一个字符串 需不需要decodeURIComponent
 */
export const needDecodeURIComponent = (text: string): boolean => {
  try {
    const decoded = decodeURIComponent(text)
    return decoded !== text
  } catch (e) {
    // 解码失败，说明不是有效的编码，不应该 decode
    return false
  }
}

/**
 * 解析当前页面的查询参数并返回一个对象
 *
 * @returns 返回一个包含查询参数的对象
 */
export const parseQueryParams = (): Record<string, string> => {
  const params: Record<string, string> = {}
  const queryString = window.location.search.slice(1)

  if (!queryString) return params

  return qs.parse(queryString) as Record<string, string>
}

/**
 * @description 获取一些公共唤端参数【使用场景 H5打开app】
 */

export const getOpenAppSensorsPublicParams = () => {
  const { messagetype, msg_channel, messageid, msg_template, source_from, msg_serviceprov, msg_id } = parseQueryParams()

  const result = {} as Record<string, string>

  if (messagetype) {
    result.messagetype = messagetype
  }

  if (msg_channel) {
    result.msg_channel = msg_channel
  }

  if (messageid || msg_id) {
    result.messageid = messageid || msg_id
  }

  if (msg_template) {
    result.msg_template = needDecodeURIComponent(msg_template) ? decodeURIComponent(msg_template) : msg_template
  }

  if (source_from) {
    result.source_from = source_from
  }

  if (msg_serviceprov) {
    result.msg_serviceprov = needDecodeURIComponent(msg_serviceprov) ? decodeURIComponent(msg_serviceprov) : msg_serviceprov
  }

  return result
}
